export const decode = (input) => {
  const txt = document.createElement('textarea');
  txt.innerHTML = input;
  return txt.value;
};

export const tpl = (input, inline) => (inline ? input : `<pre>${input}</pre>`);
